export const petFlowchart = {
  startNode: {
    id: 1,
    text: 'Do you want a pet that is active and playful?',
    options: [
      { text: 'Yes', nextNodeId: 2 },
      { text: 'No', nextNodeId: 3 },
    ],
  },
  nodes: [
    {
      id: 1,
      text: 'Do you want a pet that is active and playful?',
      options: [
        { text: 'Yes', nextNodeId: 2 },
        { text: 'No', nextNodeId: 3 },
      ],
    },
    {
      id: 2,
      text: 'Do you have a lot of space?',
      options: [
        { text: 'Yes', nextNodeId: 4 },
        { text: 'No', nextNodeId: 5 },
      ],
    },
    {
      id: 3,
      text: 'Do you want a low-maintenance pet?',
      options: [
        { text: 'Yes', nextNodeId: 6 },
        { text: 'No', nextNodeId: 7 },
      ],
    },
    {
      id: 4,
      text: 'A dog would be a great pet for you!',
      isEnd: true,
    },
    {
      id: 5,
      text: 'A cat would be a great pet for you!',
      isEnd: true,
    },
    {
      id: 6,
      text: 'A fish or a hamster would be a great pet for you!',
      isEnd: true,
    },
    {
      id: 7,
      text: 'A bird or a reptile could be a good choice for you.',
      isEnd: true,
    },
  ],
  endMessage: 'We hope this helped you decide!',
};
